export default __webpack_public_path__ + "static/media/banner2.66061e7e.svg";